<template>
    <div class="assets-detail">
        <div class="details-center">
            <div class="box2">
                <p>{{data.propertySum || '-'}}<i> {{data.propertySumUnit}}</i></p>
                <span>资产总数</span>
            </div>
            <div class="box1">
                <p>{{data.propertyAmount || '-'}}<i>万元</i></p>
                <span>资产金额</span>
            </div>
        </div>
        <hr>
        <div class="details-recode">
            <ul v-for="(item,index) in data.propertyInfoList" :key="index">
                <li class="assets-name oneRowEllipsis" >{{item.propertyName}}</li>
                <li class="assets-time oneRowEllipsis">{{item.propertyInfo}}</li>
            </ul>
        </div>
        <GoMore text="更多资产信息&gt;&gt;" :jumpUrl="data.pcUrl"/>
    </div>

</template>

<script>
    import GoMore from "./GoMore"
    export default {
        name: "Assets",
        components: {
            GoMore
        },
        props: {
            data:  { type: Object, default:()=>{}},
        },
    }
</script>

<style scoped lang="scss">
    .assets-detail{
        height: 253px;
        background: #e8eaf3;
        .details-center {
            display: flex;
            justify-content: space-around;
          box-sizing: border-box;
          padding-top: 22px;
            .box2,.box1 {
                text-align: center;
                p {
                    font-size: 28px;
                    color: #3a3550;
                    i {
                        font-size: 14px;
                        font-style: inherit;
                    }
                }
                span {
                    font-size: 12px;
                    color: #3a3550;
                }
            }
        }
        hr {
          width: 90%;
          margin:20px auto;
          border:1px dashed #995a73;
        }
        .details-recode {
            padding-left: 10px;
            padding-right: 20px;
            height: 75px;
            overflow: hidden;
            ul {
                display: flex;
                padding-left: 12px;
                padding-right: 10px;
                line-height: 25px;
                li {
                    font-size: 12px;
                    color: #3a3550;
                }
                li.assets-name {
                  width: 60%;
                  margin-right: 10px;
                }
              li.assets-time {
                width: calc(40% - 10px);

              }
            }
        }


    }

</style>